/**
 * The register: the bracketed baseline, the fourteen ticks and the figure number at the same
 * coordinate in every plate. It is what makes three separate drawings read as one set, which is
 * exactly why it is a component and not a copy: three identical copies with a warning not to edit
 * one of them alone is what this replaced.
 */
type PlateRegisterProps = {
  figure: string
  // Class names come from the calling plate's own module: the kit's paint classes are compiled
  // per-plate, so the register cannot own them.
  hairClassName: string
  hair2ClassName: string
  numberClassName: string
}

const TICKS = [26, 50, 74, 98, 122, 146, 170, 194, 218, 242, 266, 290, 314, 338]

export const PlateRegister = ({
  figure,
  hairClassName,
  hair2ClassName,
  numberClassName,
}: PlateRegisterProps) => (
  <>
    <g className={hair2ClassName}>
      <line x1="14" y1="134" x2="346" y2="134" />
      <line x1="14" y1="134" x2="14" y2="126" />
      <line x1="346" y1="134" x2="346" y2="126" />
    </g>
    <g className={hairClassName}>
      {TICKS.map((x) => (
        <line key={x} x1={x} y1="134" x2={x} y2="139" />
      ))}
    </g>
    <text className={numberClassName} x="14" y="153">
      {figure}
    </text>
  </>
)
